import { render, staticRenderFns } from "./ItemNew.vue?vue&type=template&id=3d5d6214&"
import script from "./ItemNew.vue?vue&type=script&lang=js&"
export * from "./ItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports